<!--
 - Author : wanghongling.
 - Date   : 2019/5/27.
 - File   : index.阳光食堂首页
 -->

<template>
  <div class="index-wrap">
    <div class="head-bg"></div>
    <!--左侧内容-->
    <div class="left-pos">
      <!--安全预警-->
      <transition name="slide-left1-fade">
        <yuJSafe v-show="yuJSafe" @turnTo="turnToShiTang" :selectOrgId="selectOrgId"></yuJSafe>
      </transition>
      <!--最新预警-->
      <transition name="slide-left1-fade">
        <yuJNewest v-show="yuJNewest" :selectOrgId="selectOrgId" v-on:updateMsgBoxSingleContent="updateMsgBoxSingleContent"></yuJNewest>
      </transition>
      <!--能耗监测-->
      <!--<transition name="slide-left1-fade" v-if="getViewPer.e002 === '1'">-->
        <!--<jianCeEnergy v-show="jianCeEnergy" :selectOrgId="selectOrgId"></jianCeEnergy>-->
      <!--</transition>-->
      <!--人流趋势-->
      <transition name="slide-left1-fade">
        <peopleStream v-if="jianCeEnergy" :selectOrgId="selectOrgId"></peopleStream>
      </transition>
    </div>
    <!--右侧内容-->
    <div class="right-pos">
      <!--周边餐饮-->
      <!--<transition name="slide-right1-fade" v-if="getViewPer.e001 === '1'">-->
        <!--<zBRestaurant v-show="yuJSafe" :selectOrgId="selectOrgId"></zBRestaurant>-->
      <!--</transition>-->
      <!--体温异常人员-->
      <transition name="slide-right1-fade">
        <temperature v-show="yuJNewest" :selectOrgId="selectOrgId"></temperature>
      </transition>
      <!--健康证到期人员-->
      <transition name="slide-right1-fade">
        <jKZDQPersonal v-show="yuJNewest" :selectOrgId="selectOrgId"></jKZDQPersonal>
      </transition>
      <transition name="slide-right1-fade">
        <!--承包商公示-->
        <cBSShow v-show="jianCeEnergy" :selectOrgId="selectOrgId" :state="getViewPer.e001 === '1'"></cBSShow>
      </transition>
    </div>
    <!-- 固定地图 -->
      <div  class="mapBox" v-if="!showSingleDept">
      <!--点击切换地图-->
      <transition name="slide-left1-fade">
        <!--中国地图-->
        <chinaMap v-if="isShowChina"
                  countryId="86"
                  :list="provinceList"
                  :orgId="orgId"
                  :isShowChina="isShowChina"
                  @change="getMapCity"></chinaMap>
      </transition>
      <transition name="slide-right1-fade">
        <!--省份地图-->
        <chinaMap v-if="isShowProvince"
                  :provinceId="provinceId"
                  :list="cityList"
                  @change="getMapDistrict"></chinaMap>
      </transition>

      <transition name="slide-left1-fade">
        <!--食堂点位地图-->
        <diningMap v-if="isShowCity"
                   :cityId="cityId"
                   :list="districtList"
                   @change="toDining"></diningMap>
      </transition>

      <!-- 返回按钮 -->
      <transition name="slide-left1-fade">
        <div class="back-btn" v-if="!isShowChina" @click="backFnc">
          {{ isShowProvince ? '返回总览' : '返回' }}
        </div>
      </transition>
      <excep-handle-n1 class="msg-excep-handle"
                       v-if="msgBoxSingleExVisible"
                       :isScroll="true"
                       :showChuRegion="false"
                       :current="msgBoxSingle"
                       :disabled="true"
                       @cancelFn="msgBoxSingleExVisible=false"
                       @closeEC="msgBoxSingleExVisible=false"
      ></excep-handle-n1>
    </div>

    <!-- 高德 -->
    <!--
    数据来源
    <div class="data-source">
      <tree-select :treeData="treeData" :value="value" @getValue="getValue"></tree-select>
    </div>
    地图
    <div id="container_2d" class="mapBox">
    <div  class="mapBox">
      <div v-if="this.showStatus">
        <div class="school-point" v-for="(itemSchoolList, indexSchoolList) in schoolList" :key="indexSchoolList+itemSchoolList.name" :style="{'top':itemSchoolList.pointTop,'left':itemSchoolList.pointLeft}">
          <div class="school-point-item" :class="{'gray': itemSchoolList.status === 0}">
            <div class="school-point-content" :style="{backgroundImage:'url(' + itemSchoolList.imgUrl + ')', backgroundRepeat:'no-repeat',backgroundPosition:'-7px 12px'}">
              <div class="content" @click="intoUrl(itemSchoolList.status)">{{itemSchoolList.name}}</div>
              <span class="school-point-left-shadow"></span>
              <span class="school-point-left-shine"></span>
            </div>
          </div>
        </div>
        <div class="school-point" v-for="(itemSchoolListRight, indexSchoolListRight) in itemSchoolListRight" :key="indexSchoolListRight" :style="{'top':itemSchoolListRight.pointTop,'left':itemSchoolListRight.pointLeft}">
          <div class="school-point-item" :class="{'gray': itemSchoolListRight.status === 0}">
            <div class="school-point-content-right" :style="{backgroundImage:'url(' + itemSchoolListRight.imgUrl + ')', backgroundRepeat:'no-repeat',backgroundPosition:'-7px 12px','width':itemSchoolListRight.width,'height':itemSchoolListRight.height}">
              <div class="content" @click="intoUrl(itemSchoolListRight.status)">{{itemSchoolListRight.name}}</div>
              <span class="school-point-right-shadow"></span>
              <span class="school-point-right-shine"></span>
            </div>
          </div>
        </div>
      </div>
      <excep-handle-n1 class="msg-excep-handle"
                       v-if="msgBoxSingleExVisible"
                       :isScroll="true"
                       :showChuRegion="false"
                       :current="msgBoxSingle"
                       :disabled="true"
                       @cancelFn="msgBoxSingleExVisible=false"
                       @closeEC="msgBoxSingleExVisible=false"
      ></excep-handle-n1>
    </div>
     工具栏
     <map-tool-bar v-if="showStatus === false ? true : false" :groupList="groupList" @selectGroup="getMarkerList" @mapCenter="getMapCenter"></map-tool-bar>
     -->

    <!--食堂在地图上的点位
     <div class="point-map">
          <div class="point-map-item" v-for="(item, index) in deptList" :key="index"
              @click="turnToShiTang('Shitang', item.departmentId, item.departmentName, item.exceptionCount)">
           <div :style="{transform: 'rotateZ('+360/deptList.length*index+'deg)'}">
             <div class="index-point" :style="{transform: 'rotateZ(-'+360/deptList.length*index+'deg)'}">
               <span :class="['yjWarn',item.exceptionCount>999?'fz12':'']" :title="item.exceptionCount" v-if="item.exceptionCount>0">
                  <countTo :startVal="0" :endVal="item.exceptionCount" separator="" :duration="6000">{{item.exceptionCount|shuLiangFilter}}</countTo>
                </span>
               <p>{{item.departmentName}}</p>
               <span class="river-list-trg-shadow"></span>
                <span class="river-list-trg-shine2"></span>
              </div>
           </div>
          </div>
     </div>
        <video id="index-video" class="video" src="../../static/video/index.ogg" defaultPlaybackRate=30 muted autoplay
            loop>
        </video>-->

    <!-- 地图 -->
    <div id="container_2d" class="mapBox" v-if="showSingleDept" >
      <div :style="{'background': 'url('+youxiaoImg+') no-repeat center !important','height':'100%'}">
        <div>
          <div class="school-point" v-for="(itemSchoolList, indexSchoolList) in schoolList" :key="indexSchoolList+itemSchoolList.name" :style="{'top':itemSchoolList.pointTop,'left':itemSchoolList.pointLeft}">
            <div class="school-point-item" :class="{'gray': itemSchoolList.status === 0}">
              <div class="school-point-content" :style="{backgroundImage:'url(' + itemSchoolList.imgUrl + ')', backgroundRepeat:'no-repeat',backgroundPosition:'-7px 12px'}">
                <div class="content" @click="intoUrl(itemSchoolList.status)">{{itemSchoolList.name}}</div>
                <span class="school-point-left-shadow"></span>
                <span class="school-point-left-shine"></span>
              </div>
            </div>
          </div>
        </div>
        <excep-handle-n1 class="msg-excep-handle"
                         v-if="msgBoxSingleExVisible"
                         :isScroll="true"
                         :showChuRegion="false"
                         :current="msgBoxSingle"
                         :disabled="true"
                         @cancelFn="msgBoxSingleExVisible=false"
                         @closeEC="msgBoxSingleExVisible=false"
        ></excep-handle-n1>
      </div>
    </div>
    <video v-if="showStatus" class="video" src="../../static/mapPicture/jx-map-video.mp4" muted autoplay loop>
    </video>
  </div>
</template>

<script>
import Vue from 'vue'
import yuJSafe from '@/components/index/yuJSafe'
import yuJNewest from '@/components/index/yuJNewest'
import peopleStream from '@/components/index/peopleStream'
import zBRestaurant from '@/components/index/zBRestaurant'
import temperature from '@/components/index/temperature'
import jKZDQPersonal from '@/components/index/jKZDQPersonal'
import cBSShow from '@/components/index/cBSShow'
import jianCeEnergy from '@/components/index/jianCeEnergy'
import mapToolBar from '../components/mapToolBar/mapToolBar'
import TreeSelect from '../components/TreeSelect'
import province from "../../static/mapPoint/cityPoint/province";
import youxiaoImgI from "@/assets/images/deptimg/youxiao.jpg";

export default {
  components: {
    yuJNewest,
    peopleStream,
    yuJSafe,
    zBRestaurant,
    temperature,
    jKZDQPersonal,
    cBSShow,
    jianCeEnergy,
    mapToolBar,
    TreeSelect
  },
  data() {
    return {
      map: null,
      msgBoxSingleExVisible: false,
      msgBoxSingle: {},
      yuJSafe: false,
      yuJNewest: false,
      jianCeEnergy: false,
      orgId: this.$store.getters.userInfo.orgId,
      deptList: [],
      treeData: [], // 树形结构数据
      value: '', // 数据来源默认选中的值
      imgUrl: this.$store.getters.fileApi,
      anchorList: [], // 点位列表
      anchorFilterList: [], // 过滤后的点位
      cluster: null, // 点位聚合
      groupList: [], // 点位类型集合
      markerList: [], // 海量标记的集合
      anchorIconId: '',
      showStatus: false,
      selectOrgId: '',
      provinceList: [], // 省份ID
      cityList: [], // 城市ID
      districtList: [], // 区县ID
      isShowChina: true,
      isShowProvince: false,
      isShowCity: false,
      provinceId: '',
      cityId: '',
      schoolList: [
        {
          name: '福邮校食堂',
          pointLeft: '1000px',
          pointTop: '450px',
          status: 1,
          imgUrl: '../../static/mapPicture/content-left.png'
        }
      ],
      showSingleDept:false, //单个食堂显示
      youxiaoImg:youxiaoImgI
    }
  },
  computed: {
    getViewPer() {
      return this.$store.getters.viewList
    }
  },
  mounted() {
    //this.initMap()
    this.onWebsocketMsg()
    this.getExceptionCountList()
    this.getMapAnchor()
    this.$store.dispatch('setStore/setViewList', this.orgId)
    setTimeout(() => {
      this.yuJSafe = true
    }, 100)
    setTimeout(() => {
      this.yuJNewest = true
    }, 700)
    setTimeout(() => {
      this.jianCeEnergy = true
    }, 1310)
    // 点击地图的时候，移除数据来源的select弹出窗
    document.body.addEventListener('click', () => {
        let dom = document.querySelector('.el-popper')
        let suffix = document.querySelector('.el-input--suffix')
        let arrow = document.querySelector('.el-icon-arrow-up')
        suffix && suffix.classList.remove('is-focus')
        arrow && arrow.classList.remove('is-reverse')
        dom && (dom.style.display = 'none')
    }, false)
  },
  methods: {
    /**
     * 更新最新预警提示框
     * @author: wuzp
     * @createDate: 2020/10/13
     */
    updateMsgBoxSingleContent(data){
      this.msgBoxSingleExVisible = false
      console.log('this.msgBoxSingleContent', data)
      if(data ) {
        this.msgBoxSingleExVisible = true
        this.msgBoxSingle = data
        console.log('enter this.msgBoxSingleContent', this.msgBoxSingleExVisible,this.msgBoxSingle)
      }
    },
    initMap() {
      /* eslint-disable */
      try{
        this.map = new AMap.Map('container_2d', {
          center: [119.233626, 26.030193],
          zoom: 12,
          resizeEnable: false,
          // mapStyle: 'amap://styles/d3fc11529eaf1d820d9d1d79da8a104c', // 设置地图的显示样式
          // mapStyle: 'amap://styles/blue',
          mapStyle: 'amap://styles/3422496f1fbb604bfc86de69655b5424',
          viewMode: '2D' // 使用3D视图
        })
      }catch (e){
        this.showStatus = true
      }
      this.getMapCenterFunc()
      this.getDataSourceInfo()
      this.getMapAnchorType()
    },
    /**
     * 设置中心点位
     * @author: dawangf(dawangf@sina.com)
     * @createDate: 2020/10/13
     */
    getMapCenter() {
      // this.map.setZoomAndCenter(12, [119.233626, 26.030193])
      this.getMapCenterFunc()
    },
    /**
     * @description: 获取后端返回的中心点位的函数
     * @author: linwen linwen@fjxhx.com
     * @createDate: 2020-12-11 19:01
     */
    getMapCenterFunc() {
      let params = { orgId: this.orgId }
      this.$request.mapCenterCurrentGet(params).then(res => {
        const data = res
        console.log('中心点',res)
        if (!this.showStatus) {
          this.map.setZoomAndCenter(data.plottingScale, [data.longitude, data.latitude])
        }
      }).catch(() => {
        // 没有绑定中心点位时的默认值
        if (!this.showStatus) {
          this.map.setZoomAndCenter(12, [119.233626, 26.030193])
        }
      })
    },
    /**
     * 跳转到name页面
     * @author: zhzhy
     * @createDate: 2019/6/3
     * @param name 名称
     * @param id 食堂id
     * @param deptName 食堂名称
     * @param exceptionCount 异常数量
     * @param exceptionId 异常id
     * @return {Object}
     */
    turnToShiTang(name, id, deptName, exceptionCount, exceptionId) {
      console.log('id', id)
      this.$router.push({
        name,
        query: {
          deptId: id,
          deptName: deptName,
          exceptionId: exceptionId
        }
      })
    },
    /**
     * @description: 获取数据来源传入子组件的值(树形结构的数据)
     * @author: linwen linwen@fjxhx.com
     * @createDate: 2020-12-10 15:10
     */
    getDataSourceInfo() {
      this.$request.mapAnchorScreenOrgListGet().then(res => {
        console.log('res数据结构数据：：', res)
        this.treeData.push(res)
        this.value = this.orgId
        this.selectOrgId = this.orgId
        if (!this.showStatus) {
          this.getListScreenAnchor(this.value)
        }
      })
    },
    /**
     * @author wanghongling
     * @createTime 2019/06/19
     * @description 获取各食堂异常总数
     */
    getExceptionCountList() {
      let orgId = this.$store.getters.userInfo.orgId
      this.$request.exceptionCountListGet({orgId}).then(response => {
        console.log('获取各食堂异常总数departmentName', response)
        this.deptList = response
        this.showSingleDept = false
        // this.getMarkerList(0, this.groupList[0].anchorTypeId) // 渲染地图的 InfoWindow 信息窗体
        if(this.deptList.length===1){
          // 判断是不是邮校食堂
          if(this.deptList[0].departmentId === 'D18CA078186694D1D84AE02353709E50D'){
            this.showSingleDept = true
          }
        }
      }).catch(e => {
        console.error(e)
      })
    },
    /**
     * @author wanghongling
     * @createTime 2019/06/19
     * @description websocket实时监控推送
     */
    onWebsocketMsg() {
      window.webSocket.onmessage = e => {
        if (e.data === 'heartbeat') return
        let data = JSON.parse(e.data)
        switch (data.type) {
          case 'szsa-01':
          case 'szsa-06':
          case 'szsa-07':
          case 'szsa-08':
          case 'szsa-0801':
          case 'szsa-09':
          case 'szsa-10':
          case 'szsa-11':
          case 'szsa-12':
          case 'szsa-13':
            this.getExceptionCountList()
            window.getYuJNewest(data)
            window.getYuJSafe()
            break
          case 'szsa-14':
            if (this.getViewPer.e002 === '1') {
              // window.getElecWaterData(data)
            }
            break
          case 'szsa-17':
            window.getTemp(data)
            break
          case 'szsa-18':
            this.getExceptionCountList()
            window.getYuJNewest(data)
            window.getYuJSafe()
            window.getTemp(data)
            break
          default:
            break
        }
      }
    },
    /**
     * @description: 获取地图的点位类型给 map-tool-bar用
     * @author: linwen linwen@fjxhx.com
     * @createDate: 2020-12-10 11:42
     */
    getMapAnchorType() {
      this.$request.mapAnchorDistListGet().then(res => {
        // 默认全部类型都选中
        res && res.forEach(item => item.isSelect = true )
        if (!this.$utils.isEmptyObject(res)) {
          this.groupList = []
          let tmpGroupList = res
          for (let i = 0; i < tmpGroupList.length; i += 5) {
            this.groupList.push(tmpGroupList.slice(i, i + 5))
          }
        }
        console.log('@@@@@@@@@@@@@this.groupList@@@@@@@@@@@@@@', this.groupList)
      })
    },
    /**
     * @description: map-tool-bar切换类型
     * @author: linwen linwen@fjxhx.com
     * @createDate: 2020-12-10 14:12
     * @param: map-tool-bar切换类型
     */
    getMarkerList(i, anchorTypeId) {
      // 遍历二维数组
      this.groupList.forEach(item => {
        item.forEach(group => {
          if (group.anchorTypeId === anchorTypeId) {
            group.isSelect = !group.isSelect
            let result = []
            this.anchorList.filter(g => {
              if (g.anchorTypeId === anchorTypeId) {
                result.push(g)
              }
            })
            if (group.isSelect) {
              result && result.forEach((val,idx) => {this.createMarker(idx, val)})
            } else {
              if (result) {
                result.forEach(v => this.map.remove(v.marker))
              }
            }
          }
        })
      })
    },
    /**
     * @description: 创建marker标记和信息弹窗内容
     * @author: linwen linwen@fjxhx.com
     * @createDate: 2020-12-11 18:20
     * @param: anchorObj 点位主键ID
     */
    createMarker(index, anchorObj) {

      let marker = new AMap.Marker({
        icon: new AMap.Icon({
          image: anchorObj.anchorIconId ? this.imgUrl + anchorObj.anchorIconId : require('../assets/images/marker/mark-normal.png'),
          size: new AMap.Size(40, 51),
          imageSize: new AMap.Size(40, 51)
        }),
        position: new AMap.LngLat(anchorObj.longitude, anchorObj.latitude)
      })
      let labelContent = `<div class="custom-text-label">${anchorObj.anchorName}</div>`; // 设置文本标注内容
      marker.setLabel({
        offset: new AMap.Pixel(-20, 55),
        content: labelContent
      })

      // 创建标记和标记集合用于清除
      this.map.add(marker)
      anchorObj.marker = marker
      this.markerList.push(marker)

      // 用Vue.extend构建信息窗体的内容
      let that = this
      let InfoContent = Vue.extend({
        template:
            `
          <div>
          <div class="custom-info-content" :class="{'t': vLocation.length > 1 }" v-for="item in vLocation"
               @click="toDetails(item)">
            <div class="dot"></div>
            <div class="content">{{ item.departmentName }}</div>
          </div>
          </div>`,
        data() {
          return {
            vLocation: []
          }
        },
        mounted() {
          /**
           * @description: 获取点位对应的食堂
           * @author: linwen linwen@fjxhx.com
           * @createDate: 2020-12-11 13:41
           */
          let params = {
            orgId: anchorObj.orgId,
            anchorId: anchorObj.anchorId,
            contractorId: that.selectOrgId
          }
          this.$request.deptAnchorListGet(params).then(res => {
            this.vLocation = res.list
          })
        },
        methods: {
          /**
           * @description: 跳转到对应的食堂详情
           * @author: linwen linwen@fjxhx.com
           * @createDate: 2020-12-11 10:36
           */
          toDetails(item) {
            that.turnToShiTang('Shitang', item.departmentId, item.departmentName, item.exceptionCount)
          }
        }
      })
      let infoWindow = new AMap.InfoWindow({
        anchor: 'middle-left',
        offset: new AMap.Pixel(34, -8)
      })
      let component = new InfoContent().$mount()
      infoWindow.setContent(component.$el)
      marker.on('click', () => {
        if (infoWindow.getIsOpen()) { // 窗口关闭时打开信息窗口
          infoWindow.close()
        } else {
          infoWindow.open(this.map, marker.getPosition())
        }
      })
      this.map.on('mapmove', () => {
        infoWindow.close()
      })
      this.map.on('zoomstart', () => {
        infoWindow.close()
      })
      // this.anchorClusterFunc()
    },
    /**
     * @description: 点位聚合
     * @author: linwen linwen@fjxhx.com
     * @createDate: 2020-12-11 19:21
     */
    anchorClusterFunc() {
      this.cluster = null
      this.cluster = new AMap.MarkerClusterer(this.map, this.markerList, {
        gridSize: 100,
        zIndex: 2,
        zoomOnClick: true
      })
    },
    /**
     * @description: 获取数据来源的组织体系orgId
     * @author: linwen linwen@fjxhx.com
     * @createDate: 2020-12-10 11:01
     * @param: value 获取数据来源的组织体系orgId
     */
    getValue(value) {
      this.getMapAnchorType()
      this.getListScreenAnchor(value)
      this.selectOrgId = value
    },
    /**
     * @description: 获取点位列表（大屏专用）
     * @author: linwen linwen@fjxhx.com
     * @createDate: 2020-12-10 11:04
     * @param: orgId
     */
    getListScreenAnchor(orgId) {
      let params = {
        orgId: orgId
      }
      this.$request.mapAnchorScreenListGet(params).then(res => {
        console.log('图标信息',res)
        this.anchorList = res
        // this.anchorIconId = res[0].anchorIconId
        // 清除标记和信息弹窗，然后再赋值
        if (!this.showStatus) {
          this.map.panBy(1, 1)
          this.map.remove(this.markerList)
          // 创建marker标记
          this.anchorList.forEach((item, index) => {
            item.marker && this.map.remove(item.marker)
            this.createMarker(index, item)
          })
        }
        console.log('this.anchorList', this.anchorList)
      })
    },
    /**
     * @description: 跳转到对应的食堂详情
     * @author: zsw
     * @createDate: 2021-8-6 17:47
     */
    intoUrl(status) {
      if (status === 1) {
        this.turnToShiTang('Shitang', this.deptList[0].departmentId, this.deptList[0].departmentName, this.deptList[0].exceptionCount)
      }
    },
    /**
     * 跳转到name页面
     * @author: zhzhy
     * @createDate: 2019/6/3
     * @param name 名称
     * @param id 食堂id
     * @param deptName 食堂名称
     * @param exceptionCount 异常数量
     * @param exceptionId 异常id
     * @return {Object}
     */
    toDining(name, id, deptName, exceptionCount, exceptionId) {
      this.$router.push({
        name,
        query: {
          //deptId: 'D1835071AD7CA4072A85F23A85C27A877',
          deptId: id,
          deptName: deptName,
          exceptionId: exceptionId
        }
      })
    },
    /**
     * 获取当前登录人员所属组织下所有地图点位列表（省份）
     * @author: dawangf(dawangf@sina.com)
     * @createDate: 2021/1/15
     */
    getMapAnchor(params = {countryId: '86'}) {
      this.$request.mapAnchorWebListGet(params).then(response => {
        console.log('获取当前登录人员所属组织下所有地图点位列表,省份', response)
        const tmpList = [{
          count: '1',
          provinceId: '130000',
          provinceName: '吉林省',
        }]
        response.push(...tmpList)
        this.provinceList = response
        let tmp = []
        response.forEach(value => {
          if (province[value.provinceId]) {
            // push往数组中插入新数据，{...obj1,...obj2}，将两个对象合成一个对象
            tmp.push({...value, ...province[value.provinceId]})
          }
        })
        console.log('获取当前登录人员所属组织下所有已处理的省份', tmp)
        this.provinceList = tmp
      }).catch(e => {
        console.error(e)
      })
    },
    /**
     * 关闭所有点位地图显示
     * @author: dawangf(dawangf@sina.com)
     * @createDate: 2021/1/15
     */
    hideAllMap() {
      this.isShowChina = false
      this.isShowProvince = false
      this.isShowCity = false
    },
    /**
     * 获取城市列表
     * @author: dawangf(dawangf@sina.com)
     * @createDate: 2021/1/15
     * @param provinceId 省份id
     */
    getMapCity(provinceId) {
      console.log('provinceId:', provinceId)
      if(provinceId === '130000' || provinceId === '650000') return
      this.$request.mapAnchorWebListGet({provinceId}).then(response => {
        console.log('获取城市图点位列表', response)
        this.provinceId = provinceId
        this.cityList = response
        this.hideAllMap()
        setTimeout(() => {
          this.isShowProvince = true
        }, 600)
      }).catch(e => {
        console.error(e)
      })
    },
    /**
     * 获取区县列表
     * @author: dawangf(dawangf@sina.com)
     * @createDate: 2021/1/15
     * @param provinceId 省份id
     */
     getMapDistrict(cityId) {
      console.log('cityId:', cityId)
      this.$request.mapDeptforcityListGet({"id":cityId}).then(response => {
        console.log('获取区县图点位列表', response)
        if(this.$utils.isEmptyObject(response) || this.$utils.isEmptyObject(response.data)){
          return
        }
        if(response.data.length==0){
          return
        }
        this.cityId = cityId
        this.districtList = response.data
        this.hideAllMap()
        setTimeout(() => {
          this.isShowCity = true
        }, 600)
      }).catch(e => {
        console.error(e)
      })
    },
    /**
     * 获取区县食堂列表
     * @author: dawangf(dawangf@sina.com)
     * @createDate: 2021/1/15
     * @param provinceId 省份id
     */
    getMapOrg(item) {
      console.log('districtId:', item)
      this.$request.mapAnchorWebListGet({districtId: item.districtId}).then(response => {
        console.log('获取区县组织列表', response)
        this.$set(item, 'diningList', [])
        response.forEach(val => {
          this.getMapDining(item, val.orgId)
        })
      }).catch(e => {
        console.error(e)
      })
    },
    /**
     * 获取当前体系下的食堂
     * @author: dawangf(dawangf@sina.com)
     * @createDate: 2021/1/20
     * @param item
     * @param orgId
     */
    getMapDining(item, orgId) {
      console.log('districtId:', item)
      this.$request.deptBaseListGet({orgId}).then(response => {
        console.log('获取区县食堂列表', response)
        item.diningList.push(...response.list)
        console.log('最下层-获取区县食堂列表', item.diningList)
      }).catch(e => {
        console.error(e)
      })
    },
    /**
     * 地图返回
     * @author: dawangf(dawangf@sina.com)
     * @createDate: 2021/1/20
     * @return {number}
     */
    backFnc() {
      if (this.isShowProvince) {
        this.isShowProvince = false
        return setTimeout(() => {
          this.isShowChina = true
        }, 600)
      } else {
        this.isShowCity = false
        setTimeout(() => {
          this.isShowProvince = true
        }, 600)
      }
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less">
.index-wrap {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;

  .msg-excep-handle {
    position: relative;
    left: 37.5%;
    top: 30%;
    z-index: 10;
  }

  .video {
    opacity: 1;
  }

  .head-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 85px;
    background: url('../assets/images/index/top.png') no-repeat;
    background-size: cover;
    z-index: 12;
  }

  .left-pos {
    position: absolute;
    left: 15px;
    top: 110px;
    z-index: 20;
  }

  .data-source {
    padding: 1px 15px;
    background-color: rgba(0, 0, 0, .4);
    border-radius: 12px;
    position: absolute;
    left: 460px;
    top: 110px;
    z-index: 12;

    .el-form-item {
      margin-bottom: 0px;

      .el-form-item__label {
        color: #fff;
      }
      .el-input__inner {
        height: 26px;
        line-height: 29px;
        background-color: #0d335a;
        border: 1px solid #0d4782;
        color: #409eff;
      }
      .el-select-dropdown {
        background-color: #12539a;
      }
    }
  }

  .right-pos {
    position: absolute;
    top: 110px;
    right: 15px;
    z-index: 12;
  }

  .mapBox {
    width: 100%;
    height: 100%;

    .amap-marker-label {
      border: none;
      background-color: transparent;
    }

    .custom-text-label {
      color: #fff;
      font-weight: bold;
      font-size: 14px;
    }

    .amap-info-content {
      color: #fff;
      background: #0079e9;
      border-radius: 8px;

      .amap-info-close {
        display: none;
      }

      .t:not(:nth-last-of-type(1)):before {
        content: '';
        display: block;
        width: 100%;
        height: 1px;
        background: #0097F3;
        position: absolute;
        left: 4px;
        bottom: 0px;
      }

      .amap-marker-label {
        border: 0;
        background-color: transparent;
      }

      .custom-info-label {
        color: red;
      }
    }

    .school-point {
      position: absolute;
      z-index: 18;

      .school-point-item {
        animation: triangle-animation 1.5s infinite;

        .school-point-content {
          cursor: pointer;
          color: #fff;
          position: absolute;
          padding-top: 32px;
          text-align: center;
          z-index: 3;
          width: 180px;
          height: 108px;
          text-shadow: #000 1px 0 0, #000 0 1px 0, #000 -1px 0 0, #000 0 -1px 0;
        }

        .school-point-content-right {
          cursor: pointer;
          color: #fff;
          position: absolute;
          padding-top: 32px;
          text-align: center;
          z-index: 3;
          text-shadow: #000 1px 0 0, #000 0 1px 0, #000 -1px 0 0, #000 0 -1px 0;
        }

        .school-point-left-shadow {
          display: block;
          margin: auto;
          position: absolute;
          bottom: -7px;
          right: -6px;
          height: 10px;
          width: 10px;
          background: rgba(0, 255, 255, 0.8);
          border-radius: 50%;
          z-index: 11;
          box-shadow: 1px 1px 1px 1px rgba(1, 208, 208, 0.62);
        }

        .school-point-left-shine {
          display: block;
          margin: 83px 0 0 174px;
          position: absolute;
          bottom: -15px;
          left: -49px;
          height: 15px;
          width: 15px;
          background: rgba(2, 184, 184, 0.8);
          border-radius: 50%;
          z-index: 10;
          -webkit-animation: ponit-shine 1s infinite;
          animation: ponit-shine 1s infinite;
        }

        .school-point-right-shadow {
          display: block;
          margin: auto;
          position: absolute;
          bottom: -7px;
          left: -3px;
          height: 10px;
          width: 10px;
          background: rgba(0, 255, 255, 0.8);
          border-radius: 50%;
          z-index: 11;
          box-shadow: 1px 1px 1px 1px rgba(1, 208, 208, 0.62);
        }

        .school-point-right-shine {
          display: block;
          margin: 83px 0 0 -5px;
          position: absolute;
          height: 15px;
          width: 15px;
          background: rgba(2, 184, 184, 0.8);
          border-radius: 50%;
          z-index: 10;
          -webkit-animation: ponit-shine 1s infinite;
          animation: ponit-shine 1s infinite;
        }

        @keyframes triangle-animation {
          0% {
            transform: translateY(0)
          }
          35% {
            transform: translateY(-10px)
          }
          100% {
            transform: translateY(0)
          }
        }
        @keyframes ponit-shine {
          0% {
            height: 10px;
            width: 10px;
            bottom: -7px;
            left: 2px;
            opacity: 1;
          }
          100% {
            height: 25px;
            width: 25px;
            bottom: -15px;
            left: -5px;
            opacity: 0.3;
          }
        }
      }
    }

    .amap-info-sharp {
      border-right-color: #0079e9;
    }
  }

  .point-wrap {
    font-size: 17px;
    font-weight: bold;

    .four {
      position: absolute;
      left: 510px;
      top: 530px;
      z-index: 1;
    }

    .one {
      position: absolute;
      left: 1175px;
      top: 558px;
      z-index: 1;
    }

    .two {
      position: absolute;
      left: 972px;
      top: 545px;
      z-index: 1;
    }

    .three {
      position: absolute;
      left: 510px;
      top: 688px;
      z-index: 1;
    }

  }

  .point-map {
    position: absolute;
    width: 700px;
    height: 700px;
    left: 50%;
    top: 54%;
    transform: translate(-50%, -50%);
    background: url('../assets/images/index/sa-logo.png') center 46% no-repeat;

    &-item {
      position: absolute;
      z-index: 2;
      left: 50%;
      top: 0;
      -webkit-animation: triangle-animation 1.5s infinite;
      animation: triangle-animation 1.5s infinite;
      transform-origin: 60px 350px;

      > div {
        transform-origin: 60px 350px;
        box-sizing: border-box;
        width: 123px;
        height: 65px;
        margin-left: -61.5px;
        margin-top: -32.5px;
      }
    }
  }

  .index-point {
    cursor: pointer;
    color: #fff;
    position: absolute;
    padding-top: 7px;
    z-index: 1;
    width: 123px;
    height: 65px;
    background: url('../assets/images/index/qp.png') no-repeat;
    text-shadow: #000 1px 0 0, #000 0 1px 0,#000 -1px 0 0, #000 0 -1px 0;
    -webkit-text-shadow: #000 1px 0 0, #000 0 1px 0,#000 -1px 0 0, #000 0 -1px 0;
    -moz-text-shadow: #000 2px 0 0, #000 0 1px 0,#000 -1px 0 0, #000 0 -1px 0;
    *filter: Glow(color=#000, strength=1);
    /*-webkit-animation: triangle-animation 1.5s infinite;*/
    /*animation: triangle-animation 1.5s infinite;*/

    .fz12 {
      font-size: 12px !important;
    }

    p {
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-all;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
    }

    .yjWarn {
      width: 40px;
      height: 40px;
      position: absolute;
      right: -10px;
      top: -20px;
      color: #fff;
      font-size: 15px;
      background: url("../assets/images/index/yj.png");
      background-size: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      text-shadow: rgba(0, 0, 0, 0) 1px 0 0, rgba(0, 0, 0, 0) 0 1px 0,rgba(0,0,0,0) -1px 0 0, rgba(0, 0, 0, 0) 0 -1px 0;
      -webkit-text-shadow: rgba(0, 0, 0, 0) 1px 0 0, rgba(0, 0, 0, 0) 0 1px 0,rgba(0,0,0,0) -1px 0 0, rgba(0, 0, 0, 0) 0 -1px 0;
      -moz-text-shadow: rgba(0, 0, 0, 0) 2px 0 0, rgba(0, 0, 0, 0) 0 1px 0,rgba(0,0,0,0) -1px 0 0, rgba(0, 0, 0, 0) 0 -1px 0;
      *filter: Glow(color=rgba(0, 0, 0, 0), strength=1);
      font-weight: normal;
    }
  }

  .gray {
    -webkit-filter: grayscale(1); /* Webkit */
    filter: gray; /* IE6-9 */
    filter: grayscale(1); /* W3C */
    opacity: 0.8;
  }

  .river-list-trg-shadow {
    display: block;
    margin: auto;
    position: absolute;
    top: 48px;
    left: 52px;
    height: 10px;
    width: 20px;
    background: rgba(12, 113, 7, 0.8);
    border-radius: 50%;
    z-index: 11;
    box-shadow: 1px 1px 1px 1px rgba(12, 113, 7, 0.62);
  }

  .river-list-trg-shine2 {
    display: block;
    margin: 20px 0 0 42px;
    position: absolute;
    top: 48px;
    left: 104px;
    height: 24px;
    width: 38px;
    background: rgba(36, 169, 29, .8);
    border-radius: 50%;
    z-index: 10;
    -webkit-animation: trgShadowShine 1s infinite;
    animation: trgShadowShine 1s infinite;
  }

  @keyframes triangle-animation {
    0% {
      transform: translateY(0)
    }
    35% {
      transform: translateY(-10px)
    }
    100% {
      transform: translateY(0)
    }
  }
  @keyframes trgShadowShine {
    0% {
      height: 10px;
      width: 24px;
      left: 7px;
      top: 26px;
      opacity: 1;
    }
    100% {
      height: 34px;
      width: 58px;
      left: -10px;
      top: 19px;
      opacity: 0.3;
    }
  }
  .back-btn {
    position: absolute;
    left: 903px;
    bottom: 26px;
    width: 101px;
    height: 25px;
    color: #00e4ff;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: url("../components/mapIndex/images/back1.png");
    cursor: pointer;

    &:hover {
      color: #fff;
      background: url("../components/mapIndex/images/back2.png");
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/index.vue